(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kaolenne-product-specifications"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kaolenne-specifications')) {
    customElements.define('kaolenne-specifications', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.events) return;
        this.track = this.querySelector('[data-kps-track]');
        if (!this.track) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.navigation = this.querySelector('[data-kps-navigation]');
        this.dotsContainer = this.querySelector('[data-kps-dots]');
        this.previousButton = this.querySelector('[data-kps-prev]');
        this.nextButton = this.querySelector('[data-kps-next]');
        this.status = this.querySelector('[data-kps-status]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pageSize = this.dataset.pageSize === '6' ? 6 : 4;
        this.style.setProperty('--kps-mobile-rows', String(this.pageSize / 2));
        this.index = 0;
        this.mutationObserver = new MutationObserver(() => {
          cancelAnimationFrame(this.rebuildFrame);
          this.rebuildFrame = requestAnimationFrame(() => this.buildPages());
        });
        this.mobile.addEventListener('change', () => this.updateMode(), options);
        this.addEventListener('click', event => this.onClick(event), options);
        this.addEventListener('keydown', event => this.onKeydown(event), options);
        this.addEventListener('shopify:block:select', event => {
          if (!this.isCarousel) return;
          const index = this.pages.findIndex(page => page === event.target || page.contains(event.target));
          if (index !== -1) this.goTo(index, false);
        }, options);
        this.track.addEventListener('scroll', () => {
          if (!this.isCarousel) return;
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.syncScroll());
        }, { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(() => {
          if (this.isCarousel) this.goTo(this.index, false);
        });
        this.resizeObserver.observe(this.track);
        this.buildPages();
      }

      buildPages() {
        if (!this.isConnected) return;
        this.mutationObserver.disconnect();
        const cards = Array.from(this.track.querySelectorAll('[data-kps-card]'));
        this.hidden = cards.length === 0 && !window.Shopify?.designMode;
        const fragment = document.createDocumentFragment();
        this.pages = [];
        for (let offset = 0; offset < cards.length; offset += this.pageSize) {
          const page = document.createElement('div');
          page.className = 'kps__page';
          page.id = `KpsPage-${this.dataset.blockId}-${this.pages.length + 1}`;
          cards.slice(offset, offset + this.pageSize).forEach(card => page.append(card));
          fragment.append(page);
          this.pages.push(page);
        }
        this.track.replaceChildren(fragment);
        this.dotsContainer.replaceChildren();
        this.dots = this.pages.map((page, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'kps__dot';
          dot.dataset.kpsPage = String(index);
          dot.setAttribute('aria-label', `Go to specification page ${index + 1} of ${this.pages.length}`);
          dot.setAttribute('aria-controls', page.id);
          dot.append(document.createElement('span'));
          this.dotsContainer.append(dot);
          return dot;
        });
        this.index = Math.min(this.index, Math.max(0, this.pages.length - 1));
        this.updateMode();
        this.mutationObserver.observe(this.track, { childList: true, subtree: true });
      }

      updateMode() {
        this.isCarousel = this.mobile.matches && this.dataset.mobileMode === 'carousel' && this.pages.length > 1;
        this.classList.toggle('is-carousel', this.isCarousel);
        this.navigation.hidden = !this.isCarousel;
        if (this.isCarousel) {
          this.track.setAttribute('tabindex', '0');
          this.track.setAttribute('aria-label', 'Swipe to view more specifications');
          this.goTo(this.index, false);
        } else {
          this.track.removeAttribute('tabindex');
          this.track.removeAttribute('aria-label');
          this.track.scrollLeft = 0;
          this.update(this.index);
        }
      }

      update(index) {
        this.index = index;
        this.pages.forEach((page, current) => {
          const hidden = this.isCarousel && current !== index;
          page.inert = hidden && !window.Shopify?.designMode;
          if (this.isCarousel) {
            page.setAttribute('role', 'group');
            page.setAttribute('aria-roledescription', 'slide');
            page.setAttribute('aria-label', `Specifications ${current + 1} of ${this.pages.length}`);
            page.setAttribute('aria-hidden', String(hidden));
          } else {
            for (const name of ['role', 'aria-roledescription', 'aria-label', 'aria-hidden']) page.removeAttribute(name);
          }
          this.dots[current].setAttribute('aria-current', String(current === index));
        });
        this.previousButton.disabled = index === 0;
        this.nextButton.disabled = index >= this.pages.length - 1;
        this.status.textContent = this.pages.length ? `Page ${index + 1} of ${this.pages.length}` : '';
      }

      goTo(index, animate = true) {
        if (!this.isCarousel || !this.pages.length) return;
        index = Math.max(0, Math.min(this.pages.length - 1, index));
        const edge = getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
        const delta = this.pages[index].getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
        this.track.scrollTo({ left: this.track.scrollLeft + delta, behavior: animate && !this.reducedMotion.matches ? 'smooth' : 'instant' });
        this.update(index);
      }

      syncScroll() {
        if (!this.isCarousel) return;
        const edge = getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
        const start = this.track.getBoundingClientRect()[edge];
        let nearest = 0;
        let distance = Infinity;
        this.pages.forEach((page, index) => {
          const current = Math.abs(page.getBoundingClientRect()[edge] - start);
          if (current < distance) { nearest = index; distance = current; }
        });
        this.update(nearest);
      }

      onClick(event) {
        if (!this.isCarousel || !(event.target instanceof Element)) return;
        if (event.target.closest('[data-kps-prev]')) this.goTo(this.index - 1);
        if (event.target.closest('[data-kps-next]')) this.goTo(this.index + 1);
        const dot = event.target.closest('[data-kps-page]');
        if (dot && this.dotsContainer.contains(dot)) this.goTo(Number(dot.dataset.kpsPage));
      }

      onKeydown(event) {
        if (!this.isCarousel || event.target.closest('input, textarea, select, [contenteditable="true"]')) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let next;
        if (event.key === 'ArrowRight') next = this.index + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') next = this.index + (rtl ? 1 : -1);
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = this.pages.length - 1;
        if (next === undefined) return;
        event.preventDefault();
        this.goTo(next);
        if (event.target.closest('[data-kps-page]')) this.dots[this.index].focus({ preventScroll: true });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        cancelAnimationFrame(this.rebuildFrame);
        this.events?.abort();
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        if (this.pages) this.pages.forEach(page => { page.inert = false; page.removeAttribute('aria-hidden'); });
        this.events = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
